function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M19.73,25V18.56l5.94,3.21Zm13-7.5a5,5,0,0,0-.87-2.26,3.09,3.09,0,0,0-2.2-1C26.63,14,22,14,22,14h0s-4.62,0-7.7.23a3.09,3.09,0,0,0-2.2,1,5,5,0,0,0-.87,2.26A35.59,35.59,0,0,0,11,21.13v1.73a35.56,35.56,0,0,0,.22,3.68,5,5,0,0,0,.87,2.26,3.65,3.65,0,0,0,2.43,1C16.28,30,22,30,22,30s4.62,0,7.7-.24a3.1,3.1,0,0,0,2.2-1,5,5,0,0,0,.88-2.26A35.56,35.56,0,0,0,33,22.86V21.13a35.59,35.59,0,0,0-.22-3.68h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.fb5cafd560df96b427a686167b82eb8b.svg";
export { ForwardRef as ReactComponent };